import { Api_url } from '../../common/api_url'
import { API_XANO_BASE_URL } from '../../config/api_config'
import { axiosAuth, axiosNoAuth } from '../../config/axiosInstances'

export function getLessonData(lessonID, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.GetLessonData, {
                params: {
                    lesson_id: lessonID
                }
            })
            successCallback && successCallback(response.data)
        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }

}

export function getMskillLessons(mskill_slug, user_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.GetMskillLessons, {
                params: {
                    mskill_slug: mskill_slug,
                    user_id
                }
            })

            successCallback && successCallback(response.data)
        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }

}

export function createNotes(notesData, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.CreateNotes, notesData)

            successCallback && successCallback(response?.data?.notes)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }

}

export function getNotes(user_id, lesson_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetNotes, {
                params: {
                    user_id,
                    lesson_id
                }
            })

            successCallback && successCallback(response?.data[0]?.notes)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }

}

export function getRelatedContent(searchQuery, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosNoAuth.get(`https://google-search3.p.rapidapi.com/api/v1/search/q=${searchQuery}`, {
                headers: {
                    'x-user-agent': 'desktop',
                    'x-proxy-location': 'IN',
                    'x-rapidapi-host': 'google-search3.p.rapidapi.com',
                    'x-rapidapi-key': '28cf9104abmsh8af9d9442a89575p1ac3b8jsn72655f2ae73e'
                }
            })

            successCallback && successCallback(response.data.results)

        } catch (err) {
            errorCallback && errorCallback(err)
        }
    }
}

export function getWatchedLessonsOfMskill(user_id, mskill_slug, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.GetWatchedLesson, {
                params: {
                    user_id,
                    mskill_slug
                }
            })

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }

}

export function markLessonAsWatched(user_id, lesson_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.MarkLessonWatch, {
                user_id,
                lesson_id
            })

            successCallback && successCallback(response.data)

        } catch (err) {

            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getFaqForLesson(lesson_id, successCallback, errorCallback) {
    return async function (disptach) {
        try {

            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetDoubtsForLesson, {
                params: {
                    lesson_id
                }
            })

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function createFaqForLesson(user_id, lesson_id, upgraded_faq, faq_question, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.CreateDoubtForLesson, {
                user_id,
                lesson_id,
                upgraded_faq,
                faq_question
            })

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function createReplyForFaq(faq_id, user_id, lesson_id, reply, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.CreateReplyForDoubt, {
                user_id,
                lesson_id,
                faq_id,
                reply
            })

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getMskillProgress(user_id, mskill_slug, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetMicroskillProgress, {
                params: {
                    user_id,
                    mskill_slug
                }
            })

            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getSkillProgress(user_id, skill_slug, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetSkillProgress, {
                params: {
                    user_id,
                    skill_slug
                }
            })
            //console.log(response.data);
            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function upgradetoexpertDoubt(faq_id, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.UpgradeDoubtToExpert, {
                faq_id
            })

            console.log(response.data)
            successCallback && successCallback(response.data)

        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function editNote(user_id, lesson_id, note_id, note, timestamp, successCallback, errorCallback) {
    return async function (dispatch) {
        try {

            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.EditNote, {
                user_id,
                lesson_id,
                note_id,
                note,
                timestamp
            })

            successCallback && successCallback(response.data)

        } catch (err) {
            errorCallback && errorCallback(err)
            console.log(err)
        }
    }
}
export function getTasks(
  skill_slug,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        API_XANO_BASE_URL + Api_url.GetTasks,
        {
          params: {
            skill_slug,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function createTask(
    mskill_id,
    mskill_tasks_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        API_XANO_BASE_URL + Api_url.CreateTask,
        {
          mskill_id,
          mskill_tasks_id,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function submitTask(
  user_task_id,
  formData,
  comment = '',
  type = 'submission',
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        API_XANO_BASE_URL + Api_url.SubmitTask,
        formData,

        {
          'content-type': 'multipart/form-data',
          params: {
            user_task_id,
            type,
            comment,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function upgradeUserTask(mskill_tasks_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        API_XANO_BASE_URL + Api_url.UpgradeUserTask,
        {
          mskill_tasks_id,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function markVideoUnplayable(lesson_id , successCallback ,errorCallback){
    return async function(dispatch){

        try{

            const response = await axiosNoAuth.post( API_XANO_BASE_URL + Api_url.MarkVideoUnplayable ,{
                lesson_id
            })

           successCallback && successCallback(response.data);
        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}

export function setActivationPhase(successCallback , errorCallback){
    return async function(dispatch){

        try{
            const response = await axiosAuth.post(
                API_XANO_BASE_URL + Api_url.SetActivationPhase
              );

              
        
              successCallback && successCallback(response.data);

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}

export function changeActivationSkill(skill_id, successCallback ,errorCallback){
    return async function(dispatch){
        try{

            console.log(skill_id);
            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url?.ChangeActivationSkill, { skill_id});

            successCallback && successCallback(response.data);

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}

export function getLessonFeedBack(lesson_id, attempt_list ,language , is_new_generation, successCallback ,errorCallback){
    return async function(dispatch){
        try{

        
            const response = await axiosAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:ltai_router/feedback',{params :  { lesson_id , attempt_list , language , is_new_generation }});

            successCallback && successCallback(response.data);

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}

export function setQuizTrackAttempt(quiz_id,attempt_object , is_new_generation, successCallback ,errorCallback){
    return async function(dispatch){
        try{

        
            const response = await axiosAuth.post('https://xgfy-czuw-092q.m2.xano.io/api:HYL0rVog/quiz/track_attempt', {quiz_id , attempt_object});

            successCallback && successCallback(response.data);

        }
        catch(err){
            console.log(err);
            errorCallback && errorCallback(err);
        }
    }
}
export function shareUserBadge(
    lesson_id,
    qr_link,
    successCallback,
    errorCallback
   ) {
     return async function (dispatch) {
       try {
         const response = await axiosAuth.get(
           "https://xgfy-czuw-092q.m2.xano.io/api:xforge/generate/shareable/lesson_completed_badge",{
            params : {
              lesson_id,
              qr_link
            }
  
          }
         );
   
         successCallback && successCallback(response.data);
       } catch (err) {
         console.log(err);
         errorCallback && errorCallback(err);
       }
     };
   }

// export function getSubtitles(url , successCallback , errorCallback){
//     return async function(dispatch){
//         try{

//             const response = await dispatch(' ec2-65-0-92-177.ap-south-1.compute.amazonaws.com:9000/subtitle',{params : url});
//             console.log(response);
//             // const map= {};

//             // for(let i=0;i<response.data.length ; i++){
//             //     map[response?.data?.[i]?.start] = response?.data?.[i]?.start
//             // }

//         }
//         catch(err){
//             console.log('getting error' , err);
//             errorCallback && errorCallback(err);
//         }
//     }
// }